(function() {
'use strict';

angular
    .module('core')
    .factory('paymentsService', PaymentsService);

function PaymentsService($http,
                         $q,
                         $routeParams,
                         tokeniser,
                         tripService) {
    const _clientServerCardsMap = {};
    const _cardsUrl = '/api2/payments/cards';
    const _userCardUrl = '/api2/payments/cards/customer/';
    const _enbdCardUrl = '/api2/bookings/';
    const payPalResponses = {
        cancel: 'PAYPALCANCELLED',
        fail: 'PAYPALFAILED'
    };
    const enbdOptionId = TRPCONFIG.Domain2.EnbdPaymentOptionId;

    const service = {
        checkCardNumber,
        checkCardNumberV2,
        getScheme,
        getCardFromId,
        getCardTitle,
        getLogosList,
        addCardDetails,
        removeCard,
        generateTokens,
        getSavedBookingCards,
        getEmptyPaymentDetails,
        getPayPalResponseMessage,
        cpgValidation,
        resendOtpConfirmation,
        verifyOtp
    };

    function getCardFromId(paymentOptions, cardId) {
        for (let i = 0, ii = paymentOptions.length; i < ii; i++) {
            //CardTypeId has been renamed to Id in new API.
            if (paymentOptions[i].CardTypeId === cardId || paymentOptions[i].Id === cardId) {
                return paymentOptions[i];
            }
        }
    }

    function getScheme(cardNumber) {
        return $http.get(
            `${_cardsUrl}/getscheme?cardNumber=${cardNumber}`,
            { cache: true, ignoreErrors: true }
        );
    }

    function getLogosList(paymentOptions) {
        //Removing getpaymentoptions as it became obsolete
        const logos = {
            amex: ['american express'],
            bitcoin: ['bitcoin'],
            dankort: ['dankort'],
            diners: ['diners card'],
            discover: ['discover'],
            maestro: ['maestro'],
            mastercard: ['mastercard'],
            paypal: ['paypal'],
            visa: ['visa', 'connect'],
            external: ['offline']
        };

        return _.filter(Object.keys(logos), key => _.some(logos[key], cardName => _.some(paymentOptions,
            option => _.includes(_.toLower(option.Title || option.Name), cardName))));
    }

    function checkCardNumberV2(paymentOptions, cardNumber, cardType) {
        //To support new payment option structure, not changing the old one
        if (cardNumber != null) {
            cardNumber = cardNumber.replace(/ /g, '').replace(/-/g, '');
        }

        if (TRPCONFIG.Domain.CardNumberCheckEnabled) {
            for (let i = 0, ii = paymentOptions.length; i < ii; i++) {
                //Check with master card type
                if (paymentOptions[i].CardType === cardType) {
                    if (paymentOptions[i].FeePercent > 0 || paymentOptions[i].FeeAmount > 0) {
                        return $q.when();
                    }
                }
            }
        }

        const result = getScheme(cardNumber);

        return result.then(function(res) {
            const actualType = res.data;
            if (actualType !== parseInt(cardType)) {
                return $q.reject(actualType);
            }
        }, function() {
            return cardType;
        });
    }

    function checkCardNumber(paymentOptions, cardNumber, selectedCardId) {
        if (cardNumber != null) {
            cardNumber = cardNumber.replace(/ /g, '').replace(/-/g, '');
        }

        const result = $q.all([
            _mapPaymentsType(paymentOptions),
            $http.get(
                `${_cardsUrl}/getscheme?cardNumber=${cardNumber}`,
                { cache: true, ignoreErrors: true }
            )
        ]);

        return result.then(function _numberChecker(res) {
            const verifiedClientId = _clientServerCardsMap[res[1].data];
            if (!verifiedClientId) { return; }

            if (verifiedClientId !== parseInt(selectedCardId)) {
                return $q.reject(verifiedClientId);
            } else if (verifiedClientId === parseInt(selectedCardId)) {
                return $q.resolve(verifiedClientId);
            }
        }, function() {
            return selectedCardId;
        });
    }

    function getCardTitle(paymentOptions, cardTypeId) {
        //TODO: CardTypeId, Title needs to be removed once after booking page started using new booking options API.
        for (let i = 0, ii = paymentOptions.length; i < ii; i++) {
            //CardTypeId has been renamed to Id in new API.
            const cardType = paymentOptions[i].CardTypeId || paymentOptions[i].Id;
            if (cardType === cardTypeId) {
                //Title has been renamed to Name in new API.
                return paymentOptions[i].Title || paymentOptions[i].Name;
            }
        }
    }

    function _mapPaymentsType(cp) {
        return tripService.getCurrency($routeParams.tripId).then(cur => {
            const url = `${_cardsUrl}/gettypes` +
                    `?domainId=${TRPCONFIG.Domain.DomainId
                    }&currencyCode=${cur || TRPCONFIG.Domain.CurrencyCode}`;
            return $http.get(url, { cache: true, ignoreErrors: true }).then(function _mergePaymentClientServer(res) {
                const sp = res.data;
                for (let i = 0, ii = sp.length; i < ii; i++) {
                    const clientCard = _compareTitle(cp, sp[i].Title);
                    if (clientCard) {
                        _clientServerCardsMap[sp[i].CardType] = clientCard.CardTypeId;
                    }
                }
            });
        });
    }

    function _compareTitle(paymentOptions, title) {
        for (let j = 0, jj = paymentOptions.length; j < jj; j++) {
            if (paymentOptions[j].Title === title) {
                return paymentOptions[j];
            }
        }
    }


    function addCardDetails(card, savedFrom) {
        const cardRequest = {
            MasterCardTypeId: card.paymentType,
            Number: card.CardNumber,
            MaskedCardNumber: card.MaskedCardNumber,
            ExpiryMonth: card.ExpiryDate.Month,
            ExpiryYear: card.ExpiryDate.Year,
            SavedFrom: savedFrom
        };

        return $http.post(`${_userCardUrl}set`, cardRequest, { ignoreErrors: true });
    }

    function removeCard(cardId) {
        return $http.post(`${_userCardUrl}remove`, { CardId: cardId });
    }

    function getSavedBookingCards(allowedCards) {
        const allBookingTypes = 0;
        return $http.post(`${_userCardUrl}getSavedBookingCards`, {
            domainId: TRPCONFIG.Domain.DomainId,
            currencyCode: TRPCONFIG.Domain.CurrencyCode,
            bookingTypeId: allBookingTypes// 0 to get cards for all types of booking
        }, { ignoreErrors: true }).then(function(result) {
            let savedCards = result.data;

            if (savedCards.length > 0) {
                const filteredCardList = _.filter(savedCards, function(c) {
                    return allowedCards[c.CardTypeId] !== undefined;
                });
                savedCards = _.map(filteredCardList, function(c) {
                    c.Title = allowedCards[c.CardTypeId].Title;
                    return c;
                });
            }
            return savedCards;
        }, function() {
            return null;
        });
    }

    function getEmptyPaymentDetails() {
        return {
            PaypalDetails: {
                //Not part of UserData contract in create booking
                IsPaypalPayment: false
            },
            CardDetails: {
                PaymentTypeId: 0,
                CardType: 0,
                CardNumber: null,
                StartDate: {
                    Month: null,
                    Year: null
                },
                ExpiryDate: {
                    Month: null,
                    Year: null
                },
                SecurityCode: null,
                IssueNumber: null,
                CardId: null,
                IsExpired: false
            },
            SaveThisCard: false
        };
    }

    function getPayPalResponseMessage(key) {
        return payPalResponses[key] || '';
    }

    function generateTokens(expiryMonth, expiryYear, saveCard) {
        //figure out if we need to generate tokens and if there should be an expiry
        //if pci compliant
        const requireTokens = TRPCONFIG.Domain.PCICompliant;

        const expiryDate = saveCard && expiryMonth !== 0 && expiryYear !== 0 ? new Date(expiryYear, expiryMonth) : null;

        if (saveCard && !expiryDate) {
            return $q.when(); //no point tokenising because the form is not valid
        }

        if (requireTokens) {
            return tokeniser.execute(expiryDate ? expiryDate.toISOString() : null);
        }
        return $q.when();
    }

    function cpgValidation(params) {
        const validationRequest = {
            CardNumber: params.cardNumber,
            ClientCurrencyCode: TRPCONFIG.Domain.CurrencyCode,
            DomainId: TRPCONFIG.Domain.DomainId,
            CardTypeId: enbdOptionId
        };
        return $http.post(`${_enbdCardUrl}validateenbdcardnumber`, validationRequest);
    }

    function resendOtpConfirmation(params) {
        const requestParams = {
            SessionToken: params.SessionToken,
            TransactionId: params.TransactionId,
            ClientCurrencyCode: TRPCONFIG.Domain.CurrencyCode,
            DomainId: params.domainId,
            CardTypeId: enbdOptionId
        };
        return $http.post(`${_enbdCardUrl}resendotp`, requestParams);
    }

    function verifyOtp(params) {
        const requestParams = {
            CardNumber: params.cardNumber,
            ClientCurrencyCode: TRPCONFIG.Domain.CurrencyCode,
            DomainId: params.domainId,
            CardTypeId: enbdOptionId,
            SessionToken: params.SessionToken,
            TransactionId: params.TransactionId,
            OTP: params.OTP
        };

        return $http.post(`${_enbdCardUrl}verifyotp`, requestParams);
    }


    return service;
}
})();
